import type { AxiosResponse } from "axios";
import type { HttpClient } from "@/services/baseClient";
import type {
  ApiResponse,
  AssignCaptureResult,
  DeleteCaptureResult,
  InboxCapture,
  InboxCaptureVideosResponse,
  VideoFile,
} from "@/types";

export function createTrackcastApi({ client }: HttpClient) {
  async function listInbox(): Promise<InboxCapture[]> {
    const response: AxiosResponse<ApiResponse<{ captures: InboxCapture[] }>> =
      await client.get("/trackcast/inbox");
    return response.data.data.captures;
  }

  async function assignCapture(
    captureId: string,
    sessionId: string,
  ): Promise<AssignCaptureResult> {
    const response: AxiosResponse<ApiResponse<AssignCaptureResult>> =
      await client.post(`/trackcast/inbox/${captureId}/assign`, { sessionId });
    return response.data.data;
  }

  async function getInboxCaptureVideos(
    captureId: string,
  ): Promise<VideoFile[]> {
    const response: AxiosResponse<ApiResponse<InboxCaptureVideosResponse>> =
      await client.get(`/trackcast/inbox/${captureId}/videos`);
    return response.data.data.videos;
  }

  async function deleteCapture(
    captureId: string,
  ): Promise<DeleteCaptureResult> {
    const response: AxiosResponse<ApiResponse<DeleteCaptureResult>> =
      await client.delete(`/trackcast/inbox/${captureId}`);
    return response.data.data;
  }

  return { listInbox, assignCapture, getInboxCaptureVideos, deleteCapture };
}
